import { CLIENT_ROUTES } from '@client/constants';
export const getCategoryPath = (categoryId) => `/${CLIENT_ROUTES.category}/${categoryId.toLowerCase()}`;
